import Cookies from "js-cookie";

const PostcodeChecker = el => {
  const formEl = el.querySelector("._js__postcode-checker__form");
  const submitEl = el.querySelector("._js__postcode-checker__submit");
  const showFailEl = el.querySelector('._js__postcode-checker__show-on-fail');
  const dismissFail = el.querySelector('._js__postcode-checker__fail-dismiss');
  const inputEl = el.querySelector('._js__postcode-checker__input');

  let timeout;
  
  const onSubmit = async e => {
    e.preventDefault();

    clearTimeout(timeout);
    submitEl.dataset.status = 'pending';
    const formData = new FormData(formEl);

    try {
      const result = await fetch(
        `${formEl.action}?postcode=${formData.get("postcode")}`
      );
      const json = await result.json();
      Cookies.set("postcode-checker--checked", true);

      if (json.deliversToArea) {
        submitEl.dataset.status = 'success';
      } else {
        submitEl.dataset.status = 'default';
        if (showFailEl) {
          showFailEl.classList.add('postcode-checker__show-on-fail--visible');
          showFailEl.style.maxHeight = `${showFailEl.scrollHeight}px`;
        }
      }

    } catch (error) {
      submitEl.dataset.status = 'error';
      console.warn(error);
    }

    timeout = setTimeout(() => {
      submitEl.dataset.status = 'default';
    }, 3333);
  };

  const closeFail = () => {
    showFailEl.classList.remove('postcode-checker__show-on-fail--visible');
    showFailEl.style.maxHeight = `0px`;
  }

  const onChangeInput = () => {
    closeFail();
  }

  inputEl.addEventListener('keydown', onChangeInput);
  inputEl.addEventListener('change', onChangeInput);
  formEl.addEventListener("submit", onSubmit);
  if (dismissFail) dismissFail.addEventListener('click', closeFail);
};

export default PostcodeChecker;
